import { PHONE_OFFICE, PHONE_OFFICE_DISPLAY } from "./api";

const px = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=900`;

export const HERO_IMAGE = "/brand-logo.jpg";

export const FINAL_CTA_IMAGE = px(6587827);
export const FOUNDER_IMAGE =
  "https://images.unsplash.com/photo-1778049995815-04091b798bdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const PROTOCOLS = [
  {
    slug: "ac-start",
    number: "01",
    name: "AC START",
    menuTagline: "Analisi e strategie immobiliari",
    tagline: "Analisi e strategie immobiliari",
    subtitle: "Analisi e strategie immobiliari",
    title: "Prima di decidere, conosci il tuo immobile.",
    intro:
      "«Ogni decisione immobiliare importante parte da informazioni affidabili. Con AC START analizziamo la situazione documentale, il posizionamento economico e le potenzialità del tuo immobile, integrando consulenza strategica e competenze tecniche specialistiche. Un percorso strutturato per comprendere rischi, costi, opportunità e possibili strategie, prima di vendere, acquistare, ristrutturare o investire.»",
    highlights: ["ANALISI STRATEGICA", "COMPETENZE COORDINATE", "DECISIONI CONSAPEVOLI"],
    scenarios: {
      title: "Quando attivare AC START",
      subtitle:
        "Quattro situazioni diverse. Un punto di partenza: conoscere l'immobile prima di decidere.",
      items: [
        {
          title: "Prima di acquistare",
          text: "Valuta documentazione, caratteristiche, criticità e possibili costi prima di assumere un impegno importante.",
        },
        {
          title: "Prima di vendere",
          text: "Comprendi il posizionamento dell'immobile e gli elementi che possono influenzarne il valore e la commerciabilità.",
        },
        {
          title: "Prima di ristrutturare",
          text: "Esplora gli interventi possibili, le priorità e i costi indicativi prima di pianificare i lavori.",
        },
        {
          title: "Prima di investire",
          text: "Analizza rischi, costi e potenzialità dell'immobile per costruire una valutazione economica più consapevole.",
        },
      ],
    },
    description:
      "Analisi documentale, posizionamento economico e potenzialità dell'immobile, con consulenza strategica e competenze tecniche coordinate. Un percorso per comprendere rischi, costi, opportunità e strategie prima di decidere.",
    notice:
      "AC START fornisce analisi, informazioni e supporto strategico: le verifiche di competenza tecnica sono svolte dai professionisti abilitati e il dossier non sostituisce le attestazioni previste dalla legge. Le stime sono orientative e non costituiscono preventivi definitivi.",
    heroImage:
      "https://images.unsplash.com/photo-1761499102697-17f54b78fba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    shortCopy: "Conosci l'immobile prima di decidere.",
    services: [
      {
        title: "Analisi Documentale e Verifiche Tecniche",
        text: "Coordiniamo la raccolta e l'analisi della documentazione immobiliare con il geometra partner, per individuare eventuali criticità urbanistiche e catastali e gli approfondimenti necessari. Le verifiche tecniche di competenza professionale sono svolte dai soggetti abilitati.",
        outcome:
          "Un quadro documentale organizzato, con evidenza delle verifiche effettuate, delle eventuali criticità e delle attività ancora necessarie.",
        image: px(8101391),
      },
      {
        title: "Analisi del Valore di Mercato",
        text: "Esaminiamo il posizionamento dell'immobile attraverso dati di mercato, immobili comparabili e caratteristiche specifiche della proprietà. L'obiettivo è comprendere gli elementi che incidono sul valore e sulle possibili strategie immobiliari.",
        outcome:
          "Una stima orientativa motivata, con i principali fattori che possono influenzare il valore e la commerciabilità dell'immobile.",
        image: px(6476590),
      },
      {
        title: "Potenziale e Scenari di Valorizzazione",
        text: "Analizziamo possibili interventi di miglioramento, costi indicativi e alternative di valorizzazione. Quando necessario, coinvolgiamo professionisti qualificati e l'impresa edile partner esterna per approfondire la fattibilità e i costi degli interventi.",
        outcome:
          "Una prima valutazione delle alternative di intervento, dei costi indicativi e dei possibili effetti sulla valorizzazione dell'immobile.",
        image: px(6474506),
      },
      {
        title: "Dossier Strategico AC START",
        text: "Organizziamo le informazioni raccolte, le analisi svolte e gli eventuali elaborati dei professionisti incaricati in un dossier strutturato, chiaro e consultabile. Il dossier permette di comprendere la situazione dell'immobile e individuare i possibili passi successivi.",
        outcome:
          "Un documento di sintesi con informazioni, analisi, criticità, opportunità e indicazioni strategiche utili alle decisioni successive.",
        image: px(8297536),
      },
      {
        title: "Percorso Digitale e Supporto dell'Advisor",
        text: "Attraverso l'area riservata A.C. HUB puoi consultare gli aggiornamenti, i documenti disponibili e lo stato delle attività previste dal protocollo. Il tuo Advisor rimane il riferimento per comprendere le informazioni raccolte e valutare i passaggi successivi.",
        outcome:
          "Un percorso più trasparente, con informazioni organizzate, avanzamento monitorabile e un referente strategico dedicato.",
        image: px(12969403),
      },
    ],
    finalSection: {
      title: "Non solo un'analisi. Un punto di partenza strategico.",
      text: "AC START ti aiuta a comprendere la situazione del tuo immobile prima di scegliere come procedere. Dalla vendita all'acquisto, dalla valorizzazione alla ristrutturazione, ogni decisione può partire da un quadro più chiaro. Con A.C. HUB hai un Advisor di riferimento che integra analisi, strategia e coordinamento delle competenze necessarie.",
    },
    ctaLabels: {
      primary: "Richiedi una consulenza preliminare",
      secondary: "Parla con un Advisor",
    },
    finalCta: {
      eyebrow: "AC START · Consulenza preliminare",
      title: "Valutiamo insieme il tuo immobile.",
      description:
        "Prenota un primo incontro online per approfondire le tue esigenze e valutare il percorso AC START.",
      info: "20 minuti · Gratuito · Senza impegno",
      button: "Prenota la videoconsulenza",
      microtext: "Seleziona la data e l'orario disponibili.",
    },
  },
  {
    slug: "ac-hunt",
    number: "02",
    name: "AC HUNT",
    menuTagline: "Ricerca e supporto acquisto",
    tagline: "Ricerca e supporto acquisto",
    subtitle: "Case invisibili al mercato e trattative riservate",
    description:
      "Troviamo le occasioni giuste per te, anche dove il mercato non guarda: ricerca precisa, pre-visite fatte da noi, trattativa in totale riservatezza e controllo del mutuo prima dell'offerta.",
    heroImage:
      "https://images.unsplash.com/photo-1776362355123-ca966d36e29c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    shortCopy: "Troviamo le opportunità giuste per te.",
    services: [
      {
        title: "Capire Cosa Cerchi Davvero",
        text: "Prima di cercare, capiamo: zona, caratteristiche, budget e aspettative. Partiamo da quello che vuoi tu, non da quello che c'è in vetrina.",
        image: px(7681091),
      },
      {
        title: "Case che Non Si Vedono Online",
        text: "Troviamo anche le case che non compaiono sugli annunci: vendite veloci, accordi tra privati, immobili ritirati. Le migliori occasioni non si cercano: si conoscono.",
        image: px(1396132),
      },
      {
        title: "Valutiamo Tutto, Prima di Proportela",
        text: "Prima di proporti una casa, la studiamo noi con strumenti di Intelligenza Artificiale: quanto porterebbe sistemarla e quanto vale davvero.",
        image: px(1571468),
      },
      {
        title: "Vediamo le Case al Posto Tuo",
        text: "Ti evitiamo di perdere tempo con immobili che dal vivo non corrispondono alle foto o alle aspettative. Visitiamo tutto noi, prima di te.",
        image: px(8293778),
      },
      {
        title: "Comprare al Prezzo Giusto",
        text: "Ti seguiamo passo per passo e conduciamo la trattativa per farti ottenere il miglior prezzo, difendendo i tuoi interessi.",
        image: px(8470844),
      },
      {
        title: "Prima il Mutuo, Poi l'Offerta",
        text: "Prima di fare un'offerta, controlliamo con i nostri consulenti partner che il mutuo si possa davvero avere. Niente promesse a vuoto.",
        image: px(6694543),
      },
      {
        title: "Tutti i Controlli AC START Inclusi",
        text: "Controlliamo documenti e conformità della casa con il nostro geometra di fiducia: compri senza sorprese.",
        image: px(4491459),
      },
      {
        title: "Tutto Sotto Controllo, dal Telefono",
        text: "Nel portale dedicato vedi ogni passo in tempo reale e resti sempre aggiornato, senza telefonate per sapere come va.",
        image: px(5833274),
      },
    ],
  },
  {
    slug: "ac-select",
    number: "03",
    name: "AC SELECT",
    menuTagline: "Strategie di vendita mirate",
    tagline: "Strategie di vendita mirate",
    subtitle: "La tua casa mostrata al meglio, ai compratori giusti",
    description:
      "Valorizziamo il tuo immobile al massimo: marketing su misura, prezzi calcolati sui dati veri e trattativa difesa in ogni fase, fino al rogito.",
    heroImage:
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    shortCopy: "Valorizziamo il tuo immobile sul mercato.",
    services: [
      {
        title: "La Casa al Meglio, alle Persone Giuste",
        text: "Foto e video professionali e un piano su misura per far interessare i compratori giusti, quelli con il budget giusto.",
        image: px(1643383),
      },
      {
        title: "Il Prezzo Giusto, Calcolato Bene",
        text: "Calcoliamo il prezzo giusto con l'Intelligenza Artificiale e i dati reali della tua zona: quante case si vendono, in quanto tempo e a che prezzo.",
        image: px(7567443),
      },
      {
        title: "Solo Acquirenti Seri",
        text: "Niente curiosi in casa: parliamo solo con acquirenti veri, già pronti. E conduciamo noi la trattativa per difendere il tuo prezzo.",
        image: px(8470844),
      },
      {
        title: "Affari Più Veloci",
        text: "Se l'acquirente chiede quanto costerebbe sistemare, rispondiamo subito con l'impresa partner Edilizia Cannino. E con i nostri consulenti partner controlliamo subito il suo mutuo: niente attese e niente affari che cadono.",
        image: px(5582597),
      },
      {
        title: "Sempre Informato, Fino al Rogito",
        text: "Ogni settimana ti aggiorniamo su visite e richieste. Ci occupiamo di tutta la burocrazia fino alle chiavi in mano: puoi vendere da privato o con un professionista partner del nostro network.",
        image: px(5668858),
      },
      {
        title: "Tutti i Controlli AC START Inclusi",
        text: "Controlliamo documenti e conformità della casa e prepariamo il Fascicolo Tecnico A.C. HUB, redatto con il geometra partner: arrivi al rogito senza sorprese.",
        image: px(4134179),
      },
      {
        title: "Tutto Sotto Controllo, dal Telefono",
        text: "Nel portale vedi in ogni momento come sta andando la vendita, senza dover inseguire aggiornamenti.",
        image: px(12969403),
      },
    ],
  },
  {
    slug: "ac-invest",
    number: "04",
    name: "AC INVEST",
    menuTagline: "Gestione e investimenti immobiliari",
    tagline: "Gestione e investimenti immobiliari",
    subtitle: "Investire con numeri verificati prima di impegnare capitale",
    description:
      "Costruiamo con te un piano con tre scenari (prudente, base, ottimistico): costi di acquisto, spese tecniche, ristrutturazione e prezzo di rivendita stimato. Ti mostriamo numeri e rischi prima che tu decida. Se procedi, ti coordiniamo ricerca, acquisto, lavori e rivendita o messa a reddito con i professionisti e le imprese che scegli.",
    notice:
      "Ogni operazione immobiliare comporta rischi, compresa la perdita del capitale. Le stime non sono promesse di rendimento. Tempi e costi dei lavori sono quelli definiti nel contratto tra te e l'impresa esecutrice.",
    heroImage:
      "https://images.pexels.com/photos/28054849/pexels-photo-28054849.jpeg?auto=compress&cs=tinysrgb&w=1600",
    shortCopy: "Trasformiamo il capitale in valore.",
    services: [
      {
        title: "La Strategia Giusta per Te",
        text: "Studiamo il tuo budget e scegliamo insieme la strada migliore: comprare e rivendere in breve tempo, mettere a reddito o affitti brevi.",
        image: px(7681091),
      },
      {
        title: "Case che Non Si Vedono Online",
        text: "Cerciamo anche case non in vetrina: aste, accordi prima del tribunale e vendite veloci tra privati.",
        image: px(1396132),
      },
      {
        title: "I Conti Prima di Comprare",
        text: "Prima di comprare facciamo tutti i conti: acquisto, spese, ristrutturazione e prezzo stimato di rivendita, in tre scenari (prudente, base, ottimistico). Nessun rendimento garantito: numeri e rischi, prima di decidere.",
        image: px(6694543),
      },
      {
        title: "Gestiamo Tutto, dal Cantiere alla Rivendita",
        text: "Ci occupiamo di tutto: ricerca e acquisto, controlli sull'immobile, cantiere con l'impresa partner (tempi e costi definiti nel contratto tra te e l'impresa), fino alla vendita per chiudere l'operazione.",
        image: px(8961295),
      },
      {
        title: "Tutto Sotto Controllo, dal Telefono",
        text: "Nel portale segui l'operazione in tempo reale, sempre aggiornato su ogni passo.",
        image: px(12969403),
      },
    ],
  },
  {
    slug: "ac-management",
    number: "05",
    name: "AC MANAGEMENT",
    menuTagline: "Coordinamento lavori edili",
    tagline: "Coordinamento lavori edili",
    subtitle: "Dalla progettazione al risultato finale",
    description:
      "Edilizia Cannino, impresa di famiglia attiva da oltre trent'anni, è il nostro partner esterno per i cantieri: progettazione, direzione lavori e cantiere coordinato, con tempi e costi definiti nel contratto tra te e l'impresa.",
    heroImage:
      "https://images.pexels.com/photos/7045918/pexels-photo-7045918.jpeg?auto=compress&cs=tinysrgb&w=1600",
    shortCopy: "Dalla progettazione al risultato finale.",
    services: [
      {
        title: "Dal Progetto al Cantiere",
        text: "Tecnici, architetti e professionisti del nostro network trasformano la tua idea in un progetto concreto, con costi e tempi chiari da subito. Puoi scegliere liberamente chi lavora per te: noi li selezioniamo con te e li coordiniamo.",
        image: px(6474506),
      },
      {
        title: "Edilizia Cannino, Impresa Partner",
        text: "Un'impresa di famiglia attiva da oltre trent'anni, partner esterno di A.C. HUB: sei libero di chiedere altri preventivi, li coordiniamo e li confrontiamo con lo stesso metodo. Il contratto dei lavori lo firmi direttamente con l'impresa che scegli.",
        image: px(8961295),
      },
      {
        title: "Tempi e Costi Definiti nel Contratto",
        text: "I tempi e i costi dei lavori sono quelli definiti nel contratto tra te e l'impresa esecutrice: preventivi e cronoprogramma chiari, condivisi con te.",
        image: px(20348123),
      },
      {
        title: "Un Solo Referente per il Cantiere",
        text: "Un unico referente orchestra imprese, fornitori e professionisti: il cliente vede, approva e controlla senza inseguire nessuno.",
        image: px(5833274),
      },
      {
        title: "Il Cantiere, Sempre in Vista",
        text: "Segui l'avanzamento dei lavori direttamente nel portale dedicato, con aggiornamenti periodici chiari.",
        image: px(12969403),
      },
    ],
  },
];

export const GOALS = [
  {
    id: "vendere",
    icon: "building-2",
    title: "VENDERE",
    copy: "Valorizziamo il tuo immobile e gestiamo il percorso di vendita, dal fascicolo al rogito.",
    whatsapp: "Salve, ho visto il sito di A.C. HUB, vorrei una consulenza per vendere un immobile.",
  },
  {
    id: "comprare",
    icon: "search",
    title: "COMPRARE",
    copy: "Analizziamo, cerchiamo e coordiniamo l'acquisto, anche off-market.",
    whatsapp: "Salve, ho visto il sito di A.C. HUB, vorrei una consulenza per acquistare un immobile.",
  },
  {
    id: "investire",
    icon: "trending-up",
    title: "INVESTIRE",
    copy: "Trasformiamo un'opportunità immobiliare in una strategia con ROI calcolato.",
    whatsapp: "Salve, ho visto il sito di A.C. HUB, vorrei una consulenza per un investimento immobiliare.",
  },
  {
    id: "ristrutturare",
    icon: "ruler",
    title: "RISTRUTTURARE",
    copy: "Coordiniamo progetto, professionisti e realizzazione con l'impresa partner Edilizia Cannino.",
    whatsapp: "Salve, ho visto il sito di A.C. HUB, vorrei una consulenza per ristrutturare un immobile.",
  },
  {
    id: "analizzare",
    icon: "scan-search",
    title: "ANALIZZARE",
    copy: "Mettiamo il tuo immobile sotto controllo prima di prendere qualsiasi decisione.",
    whatsapp: "Salve, ho visto il sito di A.C. HUB, vorrei una consulenza per analizzare il mio immobile.",
  },
];

export const METHOD_STEPS = [
  { n: "01", title: "ANALISI", copy: "Leggiamo obiettivo, immobile e contesto." },
  { n: "02", title: "STRATEGIA", copy: "Definiamo direzione e priorità." },
  { n: "03", title: "PROTOCOLLO", copy: "Attiviamo il percorso più adatto alla tua situazione." },
  { n: "04", title: "COORDINAMENTO", copy: "Selezioniamo i professionisti e le competenze necessarie." },
  { n: "05", title: "MONITORAGGIO", copy: "Attività e documenti ordinati. Report settimanali." },
  { n: "06", title: "RISULTATO", copy: "Portiamo il percorso alla sua destinazione." },
];

export const CONTROL_ITEMS = [
  { icon: "list-checks", label: "ATTIVITÀ" },
  { icon: "folder-open", label: "DOCUMENTI" },
  { icon: "users", label: "PROFESSIONISTI" },
  { icon: "calendar-clock", label: "SCADENZE" },
  { icon: "message-square", label: "COMUNICAZIONI" },
  { icon: "chart-no-axes-combined", label: "AVANZAMENTO" },
];

export const WHY_ITEMS = [
  { icon: "route", title: "5 PROTOCOLLI", copy: "Un metodo strutturato per ogni obiettivo." },
  { icon: "smartphone", title: "APP DEDICATA", copy: "Il percorso sempre sotto controllo, ovunque." },
  { icon: "sparkles", title: "AI 24/7", copy: "Assistenza contestuale in ogni fase." },
  { icon: "network", title: "PROFESSIONISTI SELEZIONATI", copy: "Competenze integrate nel network." },
  { icon: "shield-check", title: "CONTROLLO OPERATIVO", copy: "Attività e percorso coordinati." },
  { icon: "contact-round", title: "UNICO REFERENTE", copy: "Un punto di riferimento, sempre." },
];

export const CONTACT_LINKS = [
  { icon: "phone", label: "Ufficio A.C. HUB: 351 4129152", href: PHONE_OFFICE, testid: "contact-office" },
  { icon: "phone", label: "Alessio Cannino: 327 1757953", href: "tel:+393271757953", testid: "contact-founder" },
  { icon: "mail", label: "direzione@achubimmobiliare.it", href: "mailto:direzione@achubimmobiliare.it", testid: "contact-direction" },
  { icon: "mail", label: "alessio.cannino@achubimmobiliare.it", href: "mailto:alessio.cannino@achubimmobiliare.it", testid: "contact-alessio" },
  { icon: "file-check-2", label: "PEC: direzione@pec.achubimmobiliare.it", href: "mailto:direzione@pec.achubimmobiliare.it", testid: "contact-pec" },
  { icon: "instagram", label: "Instagram: @alessiocannino.realestate", href: "https://www.instagram.com/alessiocannino.realestate", external: true, testid: "contact-instagram" },
  { icon: "globe-2", label: "Portale digitale: portale.achubimmobiliare.it", href: "https://portale.achubimmobiliare.it", external: true, testid: "contact-portal" },
  { icon: "globe-2", label: "Edilizia Cannino — ediliziacannino.com", href: "https://ediliziacannino.com", external: true, testid: "contact-edilizia" },
];
